/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateSubscriptionTierBody,
  CustomerSubscriptionBody,
  GetBusinessOwnEnabledStatus,
  GetSubscriptionTiersResponse,
  GetSubscriptionTiersSort,
  GiftSubscriptionBody,
  SortOrder,
  SubscriptionCreatePriceBody,
  SubscriptionTier,
  SubscriptionUpdatePriceBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateSubscriptionTierBodyFromJSON,
    CreateSubscriptionTierBodyToJSON,
    CustomerSubscriptionBodyFromJSON,
    CustomerSubscriptionBodyToJSON,
    GetBusinessOwnEnabledStatusFromJSON,
    GetBusinessOwnEnabledStatusToJSON,
    GetSubscriptionTiersResponseFromJSON,
    GetSubscriptionTiersResponseToJSON,
    GetSubscriptionTiersSortFromJSON,
    GetSubscriptionTiersSortToJSON,
    GiftSubscriptionBodyFromJSON,
    GiftSubscriptionBodyToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    SubscriptionCreatePriceBodyFromJSON,
    SubscriptionCreatePriceBodyToJSON,
    SubscriptionTierFromJSON,
    SubscriptionTierToJSON,
    SubscriptionUpdatePriceBodyFromJSON,
    SubscriptionUpdatePriceBodyToJSON,
} from '../models/index';

export interface CreateSubscriptionsRequest {
    createSubscriptionTierBody?: CreateSubscriptionTierBody;
}

export interface CreateSubscriptionsGiftRequest {
    giftSubscriptionBody?: GiftSubscriptionBody;
}

export interface CreateSubscriptionsPricesRequest {
    subscriptionCreatePriceBody?: SubscriptionCreatePriceBody;
}

export interface CreateSubscriptionsSubscribeRequest {
    customerSubscriptionBody?: CustomerSubscriptionBody;
}

export interface GetSubscriptionsRequest {
    search?: string;
    sort?: GetSubscriptionTiersSort;
    isActive?: GetBusinessOwnEnabledStatus;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetSubscriptionsListRequest {
    limit?: number;
    startingAfter?: string;
    userId?: string;
}

export interface UpdateSubscriptionsIdRequest {
    id: string;
    createSubscriptionTierBody?: CreateSubscriptionTierBody;
}

export interface UpdateSubscriptionsPricesRequest {
    subscriptionUpdatePriceBody?: SubscriptionUpdatePriceBody;
}

/**
 * SubscriptionsApi - interface
 * 
 * @export
 * @interface SubscriptionsApiInterface
 */
export interface SubscriptionsApiInterface {
    /**
     * Used to create a new subscription tier
     * @param {CreateSubscriptionTierBody} [createSubscriptionTierBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    createSubscriptionsRaw(requestParameters: CreateSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionTier>>;

    /**
     * Used to create a new subscription tier
     */
    createSubscriptions(requestParameters: CreateSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionTier>;

    /**
     * Used to gift a subscription to a user
     * @param {GiftSubscriptionBody} [giftSubscriptionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    createSubscriptionsGiftRaw(requestParameters: CreateSubscriptionsGiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to gift a subscription to a user
     */
    createSubscriptionsGift(requestParameters: CreateSubscriptionsGiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Create a price for subscription.
     * @param {SubscriptionCreatePriceBody} [subscriptionCreatePriceBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    createSubscriptionsPricesRaw(requestParameters: CreateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Create a price for subscription.
     */
    createSubscriptionsPrices(requestParameters: CreateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to subscribe a customer
     * @param {CustomerSubscriptionBody} [customerSubscriptionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    createSubscriptionsSubscribeRaw(requestParameters: CreateSubscriptionsSubscribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to subscribe a customer
     */
    createSubscriptionsSubscribe(requestParameters: CreateSubscriptionsSubscribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Cancel a user\'s subscription at the end of the current phase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    deleteSubscriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancel a user\'s subscription at the end of the current phase
     */
    deleteSubscriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get a list of all subscription tiers
     * @param {string} [search] 
     * @param {GetSubscriptionTiersSort} [sort] 
     * @param {GetBusinessOwnEnabledStatus} [isActive] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    getSubscriptionsRaw(requestParameters: GetSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionTiersResponse>>;

    /**
     * Used to get a list of all subscription tiers
     */
    getSubscriptions(requestParameters: GetSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionTiersResponse>;

    /**
     * Used to get a list of all active subscriptions
     * @param {number} [limit] 
     * @param {string} [startingAfter] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    getSubscriptionsListRaw(requestParameters: GetSubscriptionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>>;

    /**
     * Used to get a list of all active subscriptions
     */
    getSubscriptionsList(requestParameters: GetSubscriptionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>>;

    /**
     * Used to get a list of user\'s active subscriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    getSubscriptionsUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Used to get a list of user\'s active subscriptions
     */
    getSubscriptionsUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Used to update an existing subscription tier
     * @param {string} id 
     * @param {CreateSubscriptionTierBody} [createSubscriptionTierBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    updateSubscriptionsIdRaw(requestParameters: UpdateSubscriptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionTier>>;

    /**
     * Used to update an existing subscription tier
     */
    updateSubscriptionsId(requestParameters: UpdateSubscriptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionTier>;

    /**
     * Toggle subscription price on / off.
     * @param {SubscriptionUpdatePriceBody} [subscriptionUpdatePriceBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    updateSubscriptionsPricesRaw(requestParameters: UpdateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Toggle subscription price on / off.
     */
    updateSubscriptionsPrices(requestParameters: UpdateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SubscriptionsApi extends runtime.BaseAPI implements SubscriptionsApiInterface {

    /**
     * Used to create a new subscription tier
     */
    async createSubscriptionsRaw(requestParameters: CreateSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionTier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubscriptionTierBodyToJSON(requestParameters['createSubscriptionTierBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionTierFromJSON(jsonValue));
    }

    /**
     * Used to create a new subscription tier
     */
    async createSubscriptions(requestParameters: CreateSubscriptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionTier> {
        const response = await this.createSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to gift a subscription to a user
     */
    async createSubscriptionsGiftRaw(requestParameters: CreateSubscriptionsGiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/gift`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GiftSubscriptionBodyToJSON(requestParameters['giftSubscriptionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to gift a subscription to a user
     */
    async createSubscriptionsGift(requestParameters: CreateSubscriptionsGiftRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSubscriptionsGiftRaw(requestParameters, initOverrides);
    }

    /**
     * Create a price for subscription.
     */
    async createSubscriptionsPricesRaw(requestParameters: CreateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/prices`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionCreatePriceBodyToJSON(requestParameters['subscriptionCreatePriceBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a price for subscription.
     */
    async createSubscriptionsPrices(requestParameters: CreateSubscriptionsPricesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSubscriptionsPricesRaw(requestParameters, initOverrides);
    }

    /**
     * Used to subscribe a customer
     */
    async createSubscriptionsSubscribeRaw(requestParameters: CreateSubscriptionsSubscribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/subscribe`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerSubscriptionBodyToJSON(requestParameters['customerSubscriptionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to subscribe a customer
     */
    async createSubscriptionsSubscribe(requestParameters: CreateSubscriptionsSubscribeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSubscriptionsSubscribeRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel a user\'s subscription at the end of the current phase
     */
    async deleteSubscriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel a user\'s subscription at the end of the current phase
     */
    async deleteSubscriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubscriptionsRaw(initOverrides);
    }

    /**
     * Used to get a list of all subscription tiers
     */
    async getSubscriptionsRaw(requestParameters: GetSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionTiersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionTiersResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all subscription tiers
     */
    async getSubscriptions(requestParameters: GetSubscriptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionTiersResponse> {
        const response = await this.getSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of all active subscriptions
     */
    async getSubscriptionsListRaw(requestParameters: GetSubscriptionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['startingAfter'] != null) {
            queryParameters['startingAfter'] = requestParameters['startingAfter'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Used to get a list of all active subscriptions
     */
    async getSubscriptionsList(requestParameters: GetSubscriptionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>> {
        const response = await this.getSubscriptionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of user\'s active subscriptions
     */
    async getSubscriptionsUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Used to get a list of user\'s active subscriptions
     */
    async getSubscriptionsUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getSubscriptionsUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to update an existing subscription tier
     */
    async updateSubscriptionsIdRaw(requestParameters: UpdateSubscriptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionTier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSubscriptionsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubscriptionTierBodyToJSON(requestParameters['createSubscriptionTierBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionTierFromJSON(jsonValue));
    }

    /**
     * Used to update an existing subscription tier
     */
    async updateSubscriptionsId(requestParameters: UpdateSubscriptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionTier> {
        const response = await this.updateSubscriptionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Toggle subscription price on / off.
     */
    async updateSubscriptionsPricesRaw(requestParameters: UpdateSubscriptionsPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/subscriptions/prices`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionUpdatePriceBodyToJSON(requestParameters['subscriptionUpdatePriceBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Toggle subscription price on / off.
     */
    async updateSubscriptionsPrices(requestParameters: UpdateSubscriptionsPricesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSubscriptionsPricesRaw(requestParameters, initOverrides);
    }

}
